import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex items-start gap-3" }
const _hoisted_2 = { class: "mb-1 text-sm font-semibold text-gray-800 dark:text-white/90" }
const _hoisted_3 = { class: "text-sm text-gray-500 dark:text-gray-400" }

import { computed } from 'vue';

interface AlertProps {
  variant: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message: string;
  showLink?: boolean;
  linkHref?: string;
  linkText?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
    variant: {},
    title: {},
    message: {},
    showLink: { type: Boolean, default: false },
    linkHref: { default: '#' },
    linkText: { default: 'Learn more' }
  },
  setup(__props: any) {

// import {
//   SuccessIcon, ErrorIcon, WarningIcon, InfoCircleIcon,
// } from '@/icons';
const props = __props;

const variantClasses = {
  success: {
    container:
      'border-green-500/30 bg-green-500/30',
    icon: 'text-success-500',
  },
  error: {
    container:
      'border-error-500/30 bg-error-500/15',
    icon: 'text-error-500',
  },
  warning: {
    container:
      'border-warning-500/30 bg-warning-500/15',
    icon: 'text-warning-500',
  },
  info: {
    container:
      'border-blue-light-500/30 bg-blue-light-500/15',
    icon: 'text-blue-light-500',
  },
};

const icons = {
  success: 'pi-check',
  error: 'pi-exclamation-triangle',
  warning: 'pi-exclamation-circle',
  info: 'pi-info-circle',
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['rounded-xl border p-4', variantClasses[_ctx.variant].container])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass(`mt-0.5 pi ${icons[_ctx.variant]} text-white`)
          }, null, 2),
          _createElementVNode("div", null, [
            _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.title), 1),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.message), 1),
            (_ctx.showLink)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: _ctx.linkHref,
                  class: "inline-block mt-3 text-sm font-medium text-gray-500 underline dark:text-gray-400"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.linkText), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})